/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationValueDtoValue } from './CreateEnumerationValueDtoValue';
import {
    CreateEnumerationValueDtoValueFromJSON,
    CreateEnumerationValueDtoValueFromJSONTyped,
    CreateEnumerationValueDtoValueToJSON,
} from './CreateEnumerationValueDtoValue';

/**
 * 
 * @export
 * @interface CreateEnumerationValueDto
 */
export interface CreateEnumerationValueDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationValueDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationValueDto
     */
    groupId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {CreateEnumerationValueDtoValue}
     * @memberof CreateEnumerationValueDto
     */
    value?: CreateEnumerationValueDtoValue | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationValueDto
     */
    isUsedForEvaluation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationValueDto
     */
    $type?: CreateEnumerationValueDtoTypeEnum;
}


/**
 * @export
 */
export const CreateEnumerationValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateEnumerationValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateEnumerationValueDtoTypeEnum = typeof CreateEnumerationValueDtoTypeEnum[keyof typeof CreateEnumerationValueDtoTypeEnum];



/**
 * Check if a given object implements the CreateEnumerationValueDto interface.
 */
export function instanceOfCreateEnumerationValueDto(value?: unknown): value is CreateEnumerationValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateEnumerationValueDtoTypeEnum)[0];
}

export function CreateEnumerationValueDtoFromJSON(json: any): CreateEnumerationValueDto {
    return CreateEnumerationValueDtoFromJSONTyped(json, false);
}

export function CreateEnumerationValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEnumerationValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'value': json['value'] == null ? undefined : CreateEnumerationValueDtoValueFromJSON(json['value']),
        'isUsedForEvaluation': json['isUsedForEvaluation'] == null ? undefined : json['isUsedForEvaluation'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateEnumerationValueDtoToJSON(value?: CreateEnumerationValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'value': CreateEnumerationValueDtoValueToJSON(value['value']),
        'isUsedForEvaluation': value['isUsedForEvaluation'],
        '$type': value['$type'],
    });
}

